import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["input", "list", "hiddenInput"]

    connect() {
        console.log('autocomplete connected');
    }

    search() {
        console.log('hello ');
        const query = this.inputTarget.value.trim()
        if (query.length < 2) {
            this.listTarget.innerHTML = ""
            return
        }
        fetch(`/administration/purchases/autocomplete?term=${encodeURIComponent(query)}`)
            .then(response => response.json())
            .then(data => {
                this.listTarget.innerHTML = ""
                data.forEach(item => {
                    const li = document.createElement("li")
                    li.textContent = item.name
                    li.addEventListener("click", () => this.select(item))
                    this.listTarget.appendChild(li)
                })
            })
            .catch(error => console.error("Error fetching suggestions:", error))
    }

    select(item) {
        this.inputTarget.value = item.name
        this.hiddenInputTarget.value = item.id
        this.listTarget.innerHTML = ""
    }
}
